import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import GroupsIcon from '@mui/icons-material/Groups';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper } from "@material-ui/core";
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import { useTranslation } from "react-i18next";
import { TeamRankingTable } from "../../components/teams/TeamRankingTable";
import Card from '@mui/material/Card';
import { Tabs, Tab } from "@material-ui/core";
import { RankingTeams1, RankingTeams2, RankingTeams3 } from "../../utils/icons";
import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from "../../api/DataProvider";

// profileData['signapoints']  >> signapointsData

export function SignaPointsDialog(props) {
  const { openDialog, setOpenDialog, setTotalSignaPoints, type, target } = props;
  const { t } = useTranslation("global")
  const [ ranking_data, setRanking_data ]  = useState([])
  const [ rankingType, setRankingType ] = useState("TOTAL_POINTS");
  const [ rankingTabValue, setRankingTabValue ] = useState(0);
  const { comm_getReportActivity, comm_updateProfile } = useCommProvider();
  const { token_id, currentUser } = useDataProvider();

  useEffect(() => {
    async function getRankingTeams() {
      setRanking_data(await comm_getReportActivity(token_id, currentUser, type, target));
    }
    
    if (openDialog){
      getRankingTeams();
    }

  }, [openDialog]);

  useEffect(() => {
    try{
      setTotalSignaPoints(ranking_data[Object.keys(ranking_data)[0]]['TOTAL_POINTS'])
    }catch{}
    
    // console.log("🚀 ~ file: SignaPointsDialog.js:48 ~ SignaPointsDialog ~ ranking_data:", ranking_data)
  }, [ranking_data]);
  

  function handleTabChange(e, newValue) {
    // console.log("🚀 ~ file: RankingTeams.js:90 ~ handleTabChange ~ handleTabChange:", handleTabChange)
    switch(newValue) {
      case 0:
        setRankingType("TOTAL_POINTS");
        break;
      case 1:
        setRankingType("VIDEO_POINTS");
        break;
      case 2:
        setRankingType("LEXICO_POINTS");
        break;
      default: 
        console.error("Unexpected new value of tab index in Team Ranking"); 
        break;
    }
    setRankingTabValue(newValue);
  }


  return (
    <>
    <Dialog className="sig_Drawer_SettingsModal_Root sig_BugReport_New_Root" open={openDialog} onClose={() => setOpenDialog(false)}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon">
        {t("sRanking.personal_score").toUpperCase()} <MilitaryTechIcon /> 
      </DialogTitle>
      <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content">

      <Card elevation={0}>
          <div className='sig_Teams_Info_Root sig_TR_Info_Root'>
            <div className='sig_Teams_MainContainer'>
              <Tabs
              className="sig_VersusMachine_Ranking_Tabs"
              TabIndicatorProps={{ style: {'backgroundColor': '#f84848'}}}
              value={rankingTabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="secondary"
              variant="fullWidth"
              centered
              >
                <Tab icon={<RankingTeams1 tabSelected={rankingTabValue === 0}/>} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.general")}/>
                <Tab icon={<RankingTeams2 tabSelected={rankingTabValue === 1}/>} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.video")}/>
                <Tab icon={<RankingTeams3 tabSelected={rankingTabValue === 2} />} className="sig_VersusMachine_Ranking_Tab" label={t("sRanking.lexicon")}/>
              </Tabs>
            </div>
          </div>
        </Card>

        <TeamRankingTable rankingData={ranking_data} rankingType={rankingType} onlyOne={true}/>

        {/* <TableContainer component={Paper}>
            <Table className="custom-table" aria-label="customized table">
                <TableHead>
                    <TableRow>
                      <TableCell className="table-header" colSpan={2} align="center"> <span> <strong>SignaPoints: </strong> {signapointsData['score']} </span> </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_inference")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['INFERENCE'] === undefined ? '-' : signapointsData['INFERENCE']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_collaboration")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['COLLABORATION'] === undefined ? '-' : signapointsData['COLLABORATION']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_donate_sign")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['DONATE_SIGN'] === undefined ? '-' : signapointsData['DONATE_SIGN']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_moveYourSkeleton")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['MOVE_YOUR_SKELETON'] === undefined ? '-' : signapointsData['MOVE_YOUR_SKELETON']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_new_sign")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['NEW_SIGN'] === undefined ? '-' : signapointsData['NEW_SIGN']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_new_variant")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['NEW_VARIANT'] === undefined ? '-' : signapointsData['NEW_VARIANT']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong> {t("sRecorder.origin_new_definition")} </strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {signapointsData['NEW_DEFINITION'] === undefined ? '-' : signapointsData['NEW_DEFINITION']} </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer> */}
        
      </DialogContent>
      
    </Dialog>
    </>
  );
}